<template>
  <div class="home-page">
    <Nav />
    <Main />
    <Organizer />
    <Speakers />
    <!-- <ConferenceProgram /> -->
    <OrganizationTeam />
    <!-- <Sponsors /> -->
    <Footer />
    
    <!-- 固定在右下角的按钮组 -->
    <div class="fixed-buttons">
      <!-- 语言切换按钮 -->
      <!-- <div class="language-switcher">
        <button 
          @click="switchLanguage('zh')" 
          :class="{ active: currentLanguage === 'zh' }"
          class="lang-btn"
          :title="$t('common.chinese')"
        >
          中
        </button>
        <button 
          @click="switchLanguage('en')" 
          :class="{ active: currentLanguage === 'en' }"
          class="lang-btn"
          :title="$t('common.english')"
        >
          EN
        </button>
      </div> -->
      
      <!-- 回到顶部按钮 -->
      <button 
        v-show="showBackToTop"
        @click="scrollToTop"
        class="back-to-top-btn"
        :title="$t('common.backToTop')"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
          <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import Nav from '@/components/Nav.vue'
import Organizer from '@/components/Organizer.vue'
import Footer from '@/components/Footer.vue'
import Main from '@/components/Main.vue'
import Speakers from '@/components/Speakers.vue'
import ConferenceProgram from '@/components/ConferenceProgram.vue'
import OrganizationTeam from '@/components/OrganizationTeam.vue'
import Sponsors from '@/components/Sponsors.vue'

const i18n = useI18n()
const { t, locale } = i18n
const currentLanguage = ref('en')
const showBackToTop = ref(false)

// 语言切换功能
const switchLanguage = (lang) => {
  locale.value = lang
  currentLanguage.value = lang
  localStorage.setItem('language', lang)
  document.title = t('common.title')
}

// 回到顶部功能
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

// 监听滚动事件，控制回到顶部按钮显示
const handleScroll = () => {
  showBackToTop.value = window.pageYOffset > 300
}

// 初始化
onMounted(() => {
  // 从localStorage恢复语言设置
  const savedLang = localStorage.getItem('language') || 'en'
  // currentLanguage.value = savedLang
  // locale.value = savedLang

  // 固定为英文
  localStorage.setItem('language', 'en')
  currentLanguage.value = 'en'
  locale.value = 'en'
  document.title = t('common.title')
  
  // 添加滚动监听
  window.addEventListener('scroll', handleScroll)
})

// 清理事件监听
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

</script>

<style scoped lang="scss">
.home-page {
  width: 100%;
  margin: 0;
  padding: 0;
}

// 固定按钮组
.fixed-buttons {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 语言切换按钮
.language-switcher {
  display: flex;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 25px;
  padding: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.lang-btn {
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  color: #666;
  cursor: pointer;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  
  &:hover {
    background-color: rgba(52, 152, 219, 0.1);
    color: #3498db;
  }
  
  &:focus {
    outline: none;
  }
  
  &.active {
    background-color: #3498db;
    color: white;
    box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
  }
}

// 回到顶部按钮
.back-to-top-btn {
  width: 50px;
  height: 50px;
  border: none;
  background-color: rgba(52, 152, 219, 0.9);
  color: white;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  outline: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  
  &:hover {
    background-color: #3498db;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(52, 152, 219, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:focus {
    outline: none;
  }
  
  svg {
    transition: transform 0.3s ease;
  }
  
  &:hover svg {
    transform: translateY(-1px);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .fixed-buttons {
    bottom: 20px;
    right: 20px;
    gap: 10px;
  }
  
  .lang-btn {
    width: 35px;
    height: 35px;
    font-size: 12px;
  }
  
  .back-to-top-btn {
    width: 45px;
    height: 45px;
  }
}

@media (max-width: 480px) {
  .fixed-buttons {
    bottom: 45px;
    right: 25px;
  }
  
  .lang-btn {
    width: 30px;
    height: 30px;
    font-size: 11px;
  }
  
  .back-to-top-btn {
    width: 40px;
    height: 40px;
  }
}

</style>